/**
 * The workflow route's search: `?run=<id>` shows a run, `&step=<id>` opens
 * one of its steps (the Inbox's link to an approval), and `?chat=<threadId>`
 * opens Ask eve on that thread (a chat's link to the chart it changed).
 *
 * @module components/workflows/workflowSearch
 */
export interface WorkflowSearch {
  readonly run?: string;
  readonly step?: string;
  readonly chat?: string;
}

const text = (value: unknown): string | null => (typeof value === "string" && value.length > 0 ? value : null);

export function parseWorkflowSearch(search: Record<string, unknown>): WorkflowSearch {
  const run = text(search.run);
  const step = run ? text(search.step) : null;
  const chat = text(search.chat);
  return { ...(run ? { run } : {}), ...(step ? { step } : {}), ...(chat ? { chat } : {}) };
}

/** The search with another run shown, or none: the step goes with the old run, the chat stays. */
export function withRun(search: WorkflowSearch, run: string | null): WorkflowSearch {
  return { ...(run ? { run } : {}), ...(search.chat ? { chat: search.chat } : {}) };
}
